<script setup lang="ts">
import large from './large.vue'
import { IconPosition, IconSizes } from '@temperworks/types'
const props = defineProps<{
  size: IconSizes
  position: IconPosition
}>()
const sizes : { [key: string]: any } = {
  large,
}

</script>

<template>
  <component
    :is="sizes[props.size]"
    :class="[position]"
  />
</template>
